<template>
  <div id="wsfilter" class="wsfilter-container">
    <div class="title">Empfängerkreis auswählen</div>
    <p>Definieren Sie Ihre Zielgruppe.</p>

    <div v-for="(group, key) in filters" :key="key">

      <!-- HEADER -->
      <div class="wsfilter-header">
        <div class="wsfilter-collapse-group">
          <div class="wsfilter-title">{{ group.title }}</div>
          <div class="wsfilter-count">
            <span id="wsfilter-group-number-of-selections-{{ key }}">{{ countGroup[group.title] }}</span>/{{ group.items.length }}
          </div>
          <div class="wsfilter-collapse">
            <a
              class="collapsed"
              role="button"
              data-toggle="collapse"
              :href="'#wsfilter-collapse-group-' + key"
              aria-expanded="false"
              :aria-controls="'wsfilter-collapse-group-' + key"
            >
              <i class="icon-up-open"></i>
            </a>
          </div>
        </div>
        <div class="wsfilter-popover">&nbsp;</div>
      </div>

      <!-- BODY -->
      <div class="wsfilter-body collapse" :id="'wsfilter-collapse-group-' + key">
        <div v-for="filter in group.items" :key="filter.id">

          <div class="wsfilter-header">
            <div class="wsfilter-collapse-group">
              <div class="wsfilter-title">{{ filter.title }}
              </div>
              <div class="wsfilter-count">
                <span :id="'wsfilter-number-of-selections-' + filter.id">{{ countFilter[filter.id] }}</span>/{{filter.types.length }}
              </div>
              <div class="wsfilter-collapse">
                <a
                  class="collapsed"
                  role="button"
                  data-toggle="collapse"
                  :href="'#wsfilter-collapse-' + filter.id"
                  aria-expanded="false"
                  :aria-controls="'#wsfilter-collapse-' + filter.id"
                >
                  <i class="icon-up-open"></i>
                </a>
              </div>
            </div>
            <div class="wsfilter-popover">
              <i class="glyphicon glyphicon-info-sign" data-container="body" data-toggle="popover" data-placement="left" data-trigger="hover" :data-title="filter.title" :data-content="filter.description" v-if="filter.description"></i>
            </div>
          </div>
          <div
            class="wsfilter-body collapse"
            :id="'wsfilter-collapse-' + filter.id"
          >
            <div class="wsfilter-form">
              <div class="form-row" v-for="type in filter.types" :key="type.value">
                <div class="input-checkbox">
                  <input
                    type="checkbox"
                    :class="'wsfilter-' + filter.id"
                    :id="'wsfilter-' + filter.id + '-' + idsFromType(type)"
                    :name="'wsfilters[' + filter.id + '][' + idsFromType(type) + ']'"
                    v-model="type.value"
                    @change="clickFilters(group, filter, type)"
                  />
                  <label :for="'wsfilter-' + filter.id + '-' + idsFromType(type)">
                    <span>{{ type.label }}</span>
                  </label>
                  <svg xml:space="preserve" viewBox="0 0 50 50" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" class="svg-inline">
                      <g xmlns="http://www.w3.org/2000/svg" id="normal">
                          <rect x="12.5" y="12.5" class="checkbox-svg-normal normal-fill" width="25" height="25"></rect>
                      </g>
                      <g xmlns="http://www.w3.org/2000/svg" id="hover">
                          <polyline class="svg-checkbox-hover" points="18.6,25.3 23.5,29.2 31.4,18.8"></polyline>
                      </g>
                      <g xmlns="http://www.w3.org/2000/svg" id="active">
                          <polyline class="svg-checkbox-stroke active-stroke" points="18.6,25.3 23.5,29.2 31.4,18.8"></polyline>
                      </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "RegionsFilter",
  props: {
    regions: Array,
    filters: Array,
  },
  data() {
    return {
      countGroup: {},
      countFilter: {},
    };
  },
  computed: {},
  created() {
    this.filters.forEach(function (group) {
      this.countGroup[group.title] = 0;
      group.items.forEach(function (filter) {
        this.countFilter[filter.id] = 0;
      }, this);
    }, this);
  },
  mounted() {},
  methods: {

    idsFromType(type) {
      return type.ids.join(",");
    },

    clickFilters(group, filter, type) {
      if (type.value) {
        this.countFilter[filter.id]++;
        if (this.countFilter[filter.id] === 1) {
          this.countGroup[group.title]++;
        }
      } else {
        this.countFilter[filter.id]--;
        if (this.countFilter[filter.id] === 0) {
          this.countGroup[group.title]--;
        }
      }
      this.$emit("update-filters");
    },
  },
};
</script>

<style lang="scss" scoped>

.checkbox-svg-normal{fill:none;stroke:#979FA7;stroke-width:1.1532;stroke-miterlimit:10;}
.svg-checkbox-hover{fill:none;stroke:#979FA7;stroke-width:2;stroke-miterlimit:10;}
.svg-checkbox-stroke{fill:none;stroke:#979FA7;stroke-width:3;stroke-miterlimit:10;}





.wsfilter-container {
  background-color: #ffffff;
  /*border: solid 1px #cdcdcd;*/
  border-radius: 2px;
  box-shadow: 1px 1px 15px grey;
  padding: 20px;
  color: #333333;
  margin-bottom: 25px;

  .title {
    font-weight: 800;
    font-size: 18px;
    margin-bottom: 5px;
  }

  p {
    margin-bottom: 0px;
  }
}

.wsfilter-header {
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  margin: 15px 0 5px;
}

.wsfilter-collapse-group {
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
}

.wsfilter-popover {
  display: flex;
  min-width: 36px;
  justify-content: flex-end;

  .glyphicon {
    padding: 0 10px;
  }
}

.wsfilter-body {
  margin-left: 1rem;
}

.wsfilter-body .wsfilter-body {
  margin-left: 0;
}

.wsfilter-title {
  width: 100%;
}

.wsfilter-collapse {
  padding-left: 5px;
}

.wsfilter-collapse a {
  color: #333333;
}

.wsfilter-collapse a::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0,0,0,0);
}

.wsfilter-collapse .collapsed .icon-up-open:before {
  content: '\e815';
}






/* Checkbox */
#wsfilter .input-checkbox,
#wsfilter .input-radio {
  width: auto;
  display: inline-block;
  position: relative;
  top: 0;
  left: 0;
}

#wsfilter .input-checkbox input[type=checkbox],
#wsfilter .input-radio input[type=radio] {
  width: 2.5rem;
  height: 2.5rem;
  z-index: 99;
  opacity: 0;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0 0 0 1rem;
  /*color: #363a3e;*/
  border: 1px solid #6e6e6e;
  background: #fff;
  border-radius: 3px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

#wsfilter .input-checkbox label,
#wsfilter .input-radio label {
  width: 100%;
  height: 100%;
  padding: .8rem 10px 0 2.5rem;
  cursor: pointer;
  z-index: 2;
  margin-bottom: .2rem;
  font-size: 16px;
  color: #333333;
}

#wsfilter .input-checkbox svg,
#wsfilter .input-radio svg {
  width: 2.5rem;
  height: 2.5rem;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

/* normal */
#wsfilter .input-checkbox svg .normal-fill,
#wsfilter .input-radio svg .normal-fill {
  fill: #fff;
}

#wsfilter .svg-inline .normal-fill {
  fill: #4D4D4D;
  -webkit-transition: fill .3s ease;
  transition: fill .3s ease;
}

#wsfilter .checkbox-svg-normal {
  stroke: #979FA7;
  stroke-width: 1.1532;
  stroke-miterlimit: 10;
}

/* hover */
#wsfilter .input-checkbox:hover svg #hover,
#wsfilter .input-radio:hover svg #hover {
  display: block;
  -webkit-transform: scale(1);
  transform: scale(1);
}

#wsfilter .input-checkbox svg #hover,
#wsfilter .input-radio svg #hover {
  transform: scale(0);
  transform-origin: 50% 50%;
  transition: transform .2s ease;
}

#wsfilter .svg-inline #hover {
  display: none;
}

#wsfilter .svg-checkbox-hover {
  fill: none;
  stroke: #979FA7;
  stroke-width: 2;
  stroke-miterlimit: 10;
}

/* active */
#wsfilter .input-checkbox input[type=checkbox]:checked+label+svg #active,
#wsfilter .input-radio input[type=radio]:checked+label+svg #active {
  display: block;
}
#wsfilter .svg-inline #active {
  display: none;
}

#wsfilter .svg-inline .active-stroke {
  stroke: #ce1a0f;
}

#wsfilter .svg-checkbox-stroke {
  fill: none;
  stroke: #979FA7;
  stroke-width: 3;
  stroke-miterlimit: 10;
}
</style>
